export default __webpack_public_path__ + "091c01c8cd4d40402b3b97c3badeccfb.svg";